__turbopack_context__.v({
  "action": "AlertBanner-module__BsSXFa__action",
  "banner": "AlertBanner-module__BsSXFa__banner",
  "content": "AlertBanner-module__BsSXFa__content",
  "description": "AlertBanner-module__BsSXFa__description",
  "dismiss": "AlertBanner-module__BsSXFa__dismiss",
  "error": "AlertBanner-module__BsSXFa__error",
  "info": "AlertBanner-module__BsSXFa__info",
  "success": "AlertBanner-module__BsSXFa__success",
  "title": "AlertBanner-module__BsSXFa__title",
  "warning": "AlertBanner-module__BsSXFa__warning",
});
